<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.PLUGINS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x4 sp-store-details-general-plugin__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info
      [label]="'cms'"
      [content]="store?.cms || ''"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-status-indicator
      [label]="'STORES.PRODUCT_PREVIEW_TITLE'"
      [status_class]="
        getCompanySettingsBackgroundClass(store?.plugin_preferences?.is_product_preview_enabled || false)
      ">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.PRODUCT_PREVIEW_MODAL_TITLE'"
      [status_class]="
        getCompanySettingsBackgroundClass(store?.plugin_preferences?.is_product_preview_modal_enabled || false)
      ">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.PRODUCT_PREVIEW_PRICE_TITLE'"
      [status_class]="
        getCompanySettingsBackgroundClass(store?.plugin_preferences?.is_product_preview_price_enabled || false)
      ">
    </app-shared-status-indicator>
    <app-shared-info
      [label]="'STORES.PRODUCT_PREVIEW_POSITION_TITLE'"
      [content]="getProductLabel(store?.plugin_preferences?.product_preview_position || '')"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-status-indicator
      [label]="'STORES.CART_PREVIEW_TITLE'"
      [status_class]="getCompanySettingsBackgroundClass(store?.plugin_preferences?.is_cart_preview_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'STORES.CART_PREVIEW_PRICE_TITLE'"
      [status_class]="
        getCompanySettingsBackgroundClass(store?.plugin_preferences?.is_cart_preview_price_enabled || false)
      ">
    </app-shared-status-indicator>
    <app-shared-info
      [label]="'STORES.CART_PREVIEW_POSITION_TITLE'"
      [content]="getCartLabel(store?.plugin_preferences?.cart_preview_position || '')"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2"></div>
</div>
